import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "../mychart/MyChartContainer";

const Estimatations = (props) => {
    logUI("MBHWeb.UI.Estimatations.ComponentDidMount", new Date(), Tools.getURLPath());
    const serverData = props.serverData;
    const heading = <div className="row">
        <div className="col-12 col-md-6">
            <h1 className="page-heading dt-heading-line">Overview</h1>
        </div>
    </div>;
    return <MyChartContainer mode="patientestimates" serverData={serverData} heading={heading}/>;
};

export default Estimatations;